module.exports = __webpack_public_path__ + "img/Support-skill-614.22bfb43e.png";